import axios from "axios";
import {
  CARD_ITEM_DECREMENT,
  CARD_ITEM_INCREMENT,
  CARD_ITEM_INCREMENT_DECREMENT_SERVER_SIDE_ERROR_OR_DONE,
  CARD_ITEM_INCREMENT_DECREMENT_SERVER_SIDE_LOADING,
  CARD_ITEM_VALUE_REMOVE,
  CARD_ITEM_VALUE_REMOVE_SERVER_SIDE_ERROR_OR_DONE,
  CARD_ITEM_VALUE_REMOVE_SERVER_SIDE_LOADING,
  CLEAR_FILTERS,
  GET_CARD_ITEMS,
  GET_CARD_ITEMS_ERROR,
  GET_CARD_ITEMS_LOADING,
  GET_GROUP_SIZE_LIST,
  GET_GROUP_SIZE_LIST_ERROR,
  GET_GROUP_SIZE_LOADING,
  GET_LIKE_ITEMS,
  GET_LIKE_ITEMS_ERROR,
  GET_LIKE_ITEMS_LOADING,
  GET_PRODUCT_ERROR,
  GET_PRODUCT_LIST,
  LIKE_ITEM_VALUE_ADD,
  LIKE_UNLIKE_SERVER_SIDE_ERROR_DONE,
  LIKE_UNLIKE_SERVER_SIDE_LOADING,
  LIST_ORDER_ITEM,
  LIST_ORDER_ITEM_ERROR,
  LIST_ORDER_ITEM_LOADING,
  PLACE_ORDER_ITEMS,
  PLACE_ORDER_ITEMS_ERROR,
  PLACE_ORDER_ITEMS_LOADING,
  REMARK_ITEM_STATE_CHANGE,
  SET_CARD_QTY_AND_TOTAL,
  SET_CATEGORY_VALUE,
  SET_FILTER,
  SET_GENDER_CHECK_VALUE,
  SET_GROUP_ID_STATE_CHANGE,
  SET_ITEM_GROUP_VALUE,
  SET_PAGINATION_LIST_END,
  SET_SIZE_ID_STATE_CHANGE,
  SET_SUB_CATEGORY_VALUE,
  UNLIKE_ITEM_VALUE_REMOVE,
  SET_GROUP_MODEL,
  SET_SIZE_MODEL,
  SET_REMARK_MODEL,
  GET_FILTER_VALUE,
  PRODUCT_RESET,
  EDIT_ORDER_ITEM_ERROR,
  EDIT_ORDER_ITEM_BY_ID,
  EDIT_ORDER_ITEM_LOADING,
  SET_LOADING_PAGINATION,
  SET_SEARCH,
  PRODUCT_DETAIL_INDEX,
  GET_SIZE_LIST_ERROR,
  GET_SIZE_LIST,
  GET_SIZE_LOADING,
  ORDERBY_TOGGLE,
  GLOBLE_CATEGORY_ID,
} from "./types";
import { LogOutAction } from "./authAction";
import toast from "react-hot-toast";

export const setRemarkModalValues = (productObj, remark) => (dispatch) => {
  dispatch({
    type: SET_REMARK_MODEL,
    payloadProductObj: productObj,
    payloadRemark: remark,
  });
};

export const setSizeModalValues =
  (productObj, sizeId, isProduuctDetails = false) =>
  (dispatch) => {
    dispatch({
      type: SET_SIZE_MODEL,
      payloadProductObj: productObj,
      payloadSizeId: sizeId,
      payloadProductDetails: isProduuctDetails,
    });
  };

export const setSearchModelAction =
  (searchValue = "") =>
  (dispatch) => {
    dispatch({
      type: SET_SEARCH,
      payload: searchValue,
    });
  };

export const setGroupModalValues =
  (productObj, groupId, isProduuctDetails = false) =>
  (dispatch) => {
    dispatch({
      type: SET_GROUP_MODEL,
      payloadProductObj: productObj,
      payloadGroupId: groupId,
      payloadProductDetails: isProduuctDetails,
    });
  };

export const setGenderCheckValue = (itemId) => (dispatch) => {
  dispatch({
    type: SET_GENDER_CHECK_VALUE,
    payloadId: itemId,
  });
};

export const setSubCategoryCheckValue = (itemId) => (dispatch) => {
  dispatch({
    type: SET_SUB_CATEGORY_VALUE,
    payloadId: itemId,
  });
};

export const setCategoryCheckValue = (itemId) => (dispatch) => {
  dispatch({
    type: SET_CATEGORY_VALUE,
    payloadId: itemId,
  });
};

export const setItemGroupCheckValue = (itemId) => (dispatch) => {
  dispatch({
    type: SET_ITEM_GROUP_VALUE,
    payloadId: itemId,
  });
};

export const clearAllFilter = () => (dispatch) => {
  dispatch({
    type: CLEAR_FILTERS,
  });
  dispatch({
    type: PRODUCT_RESET,
  });
  // dispatch(getProductsAction());
};

export const applyFilterAction =
  (Category = null) =>
  (dispatch) => {
    dispatch({
      type: PRODUCT_RESET,
    });

    dispatch({
      type: SET_FILTER,
      payloadNavigation: Category,
    });

    dispatch(getProductsAction());
  };

export const getProductsAction = () => (dispatch, getState) => {
  try {
    const {
      authState: { userToken, stoneValue, weightValue },
      productState: {
        filterValue = "",
        paginationLoading,
        isListEndProduct,
        offsetProduct,
        searchTextState,
        orderby,
      },
    } = getState();

    if (!paginationLoading) {
      dispatch({
        type: SET_LOADING_PAGINATION,
        payload: true,
      });

      var sendObj = JSON.stringify({
        offset: offsetProduct,
        limit: 10,
        sub_category: filterValue.subCategory,
        gender: filterValue.gender,
        item_group: filterValue.itemGroup,
        category: filterValue.category,
        search_text: searchTextState,
        from_stone_percentage: stoneValue[0],
        to_stone_percentage: stoneValue[1],
        from_weight_percentage: weightValue[0],
        to_weight_percentage: weightValue[1],
        order_by: orderby,
      });

      console.log(sendObj);

      var config = {
        method: "post",
        url: "https://admin.aynajewels.in/amrut1api/items",
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: sendObj,
      };

      axios(config)
        .then(function (response) {
          if (
            response &&
            response.data &&
            response.data.status === false &&
            response.data.msg.includes("Invalid Token")
          ) {
            dispatch(LogOutAction());
          }

          if (response.data.data.length > 0) {
            dispatch({
              type: GET_PRODUCT_LIST,
              payload: response.data.data,
            });
          } else {
            dispatch({
              type: SET_LOADING_PAGINATION,
              payload: false,
            });
            dispatch({
              type: SET_PAGINATION_LIST_END,
              payload: true,
            });
          }
        })
        .catch(function (error) {
          dispatch({
            type: GET_PRODUCT_ERROR,
            payload: "server response failed",
          });
          dispatch({
            type: SET_LOADING_PAGINATION,
            payload: false,
          });
          dispatch({
            type: SET_PAGINATION_LIST_END,
            payload: true,
          });
        });
    }
  } catch (e) {
    dispatch({
      type: GET_PRODUCT_ERROR,
      payload: "server response failed",
    });
    dispatch({
      type: SET_LOADING_PAGINATION,
      action: false,
    });
    dispatch({
      type: SET_PAGINATION_LIST_END,
      action: true,
    });
  }
};

export const addCardItemsAction =
  (
    projectId,
    productQty = "0",
    typeOfQty = "*",
    itemGroupId = null,
    itemSizeId = null,
    remark = null,
    editState = "", // addtocard, +,-,remark, size, group
    subcategory = ""
  ) =>
  async (dispatch, getState) => {
    dispatch({
      type: CARD_ITEM_INCREMENT_DECREMENT_SERVER_SIDE_LOADING,
    });

    let cardQtyForServer = productQty;
    if (typeOfQty === "+") {
      // card Stateechange mate karlu che
      // add to card ma this not going to run
      cardQtyForServer = "1";
      // dispatch({
      //   type: CARD_ITEM_INCREMENT,
      //   payloadProductId: projectId,
      // });
    } else if (typeOfQty === "-") {
      // card Stateechange mate karlu che
      // add to card ma this not going to run
      cardQtyForServer = "-1";
      // dispatch({
      //   type: CARD_ITEM_DECREMENT,
      //   payloadProductId: projectId,
      // });
    }

    try {
      const {
        authState: { userToken },
      } = getState();

      var dataObj = JSON.stringify({
        item_config_id: projectId,
        qty: cardQtyForServer,
        action: "add",
        group_id: itemGroupId,
        size_id: itemSizeId,
        remark: remark,
        item_sub_data: subcategory,
      });

      console.log(dataObj);

      var config = {
        method: "post",
        url: "https://admin.aynajewels.in/amrut1api/home/update_cart",
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: dataObj,
      };

      axios(config)
        .then(function (response) {
          console.log(response.data);

          if (
            response &&
            response.data &&
            response.data.message &&
            response.data.status === false &&
            response.data.message.includes("Invalid Token")
          ) {
            dispatch(LogOutAction());
          }

          if (response && response.data && response.data.status) {
            if (typeOfQty === "+") {
              // card Stateechange mate karlu che
              // add to card ma this not going to run
              // cardQtyForServer = "1";
              dispatch({
                type: CARD_ITEM_INCREMENT,
                payloadProductId: projectId,
              });
            } else if (typeOfQty === "-") {
              // card Stateechange mate karlu che
              // add to card ma this not going to run
              // cardQtyForServer = "-1";
              dispatch({
                type: CARD_ITEM_DECREMENT,
                payloadProductId: projectId,
              });
            }

            if (editState === "remark") {
              dispatch({
                type: REMARK_ITEM_STATE_CHANGE,
                payloadProductId: projectId,
                payloadRemark: remark,
              });
            } else if (editState === "size") {
              dispatch({
                type: SET_SIZE_ID_STATE_CHANGE,
                payloadProductId: projectId,
                payload: itemSizeId,
              });
            } else if (editState === "group") {
              dispatch({
                type: SET_GROUP_ID_STATE_CHANGE,
                payloadProductId: projectId,
                payload: itemGroupId,
              });
            }

            let totalReposneQty =
              response.data.totaldata && response.data.totaldata.total_qty
                ? response.data.totaldata.total_qty
                : 0;
            let totalReponseGr =
              response.data.totaldata && response.data.totaldata.total_gr
                ? response.data.totaldata.total_gr
                : 0;

            dispatch({
              type: SET_CARD_QTY_AND_TOTAL,
              payloadTotalCardvalue: parseFloat(totalReponseGr),
              payloadQty: parseInt(totalReposneQty),
            });
            toast.success(
              `Item successfully ${
                typeOfQty === "-" ? "removed from cart" : "added into cart"
              }`
            );
            dispatch({
              type: CARD_ITEM_INCREMENT_DECREMENT_SERVER_SIDE_ERROR_OR_DONE,
            });
            // dispatch(getCardItemsAction());
          } else {
            dispatch({
              type: CARD_ITEM_INCREMENT_DECREMENT_SERVER_SIDE_ERROR_OR_DONE,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: CARD_ITEM_INCREMENT_DECREMENT_SERVER_SIDE_ERROR_OR_DONE,
          });
        });
    } catch (e) {}
  };

export const RemoveCardItemsAction =
  (projectId) => async (dispatch, getState) => {
    dispatch({
      type: CARD_ITEM_VALUE_REMOVE_SERVER_SIDE_LOADING,
    });

    dispatch({
      type: CARD_ITEM_VALUE_REMOVE,
      payloadProductId: projectId,
    });

    try {
      const {
        authState: { userToken },
      } = getState();

      var dataObj = JSON.stringify({ id: projectId });

      var config = {
        method: "post",
        url: "https://admin.aynajewels.in/amrut1api/home/remove_cart",
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: dataObj,
      };

      axios(config)
        .then(function (response) {
          if (
            response &&
            response.data &&
            response.data.msg &&
            response.data.status === false &&
            response.data.msg.includes("Invalid Token")
          ) {
            dispatch(LogOutAction());
          }

          if (response && response.data && response.data.status) {
            let totalReposneQty =
              response.data.totaldata && response.data.totaldata.total_qty
                ? response.data.totaldata.total_qty
                : 0;
            let totalReponseGr =
              response.data.totaldata && response.data.totaldata.total_gr
                ? response.data.totaldata.total_gr
                : 0;

            dispatch({
              type: SET_CARD_QTY_AND_TOTAL,
              payloadTotalCardvalue: parseFloat(totalReponseGr),
              payloadQty: parseInt(totalReposneQty),
            });

            // dispatch(getCardItemsAction());

            dispatch({
              type: CARD_ITEM_VALUE_REMOVE_SERVER_SIDE_ERROR_OR_DONE,
            });
          } else {
            dispatch({
              type: CARD_ITEM_VALUE_REMOVE_SERVER_SIDE_ERROR_OR_DONE,
            });
          }
        })
        .catch(function (error) {
          dispatch({
            type: CARD_ITEM_VALUE_REMOVE_SERVER_SIDE_ERROR_OR_DONE,
          });
        });
    } catch (e) {}
  };

export const getLikeCardItemsAction = () => async (dispatch, getState) => {
  dispatch({
    type: GET_LIKE_ITEMS_LOADING,
  });

  dispatch({
    type: PRODUCT_RESET,
  });

  try {
    const {
      authState: { userToken },
    } = getState();

    var emptyObj = JSON.stringify({});

    var config = {
      method: "post",
      url: "https://admin.aynajewels.in/amrut1api/home/wishlist",
      headers: {
        "If-Range": userToken,
        "Content-Type": "application/json",
      },
      data: emptyObj,
    };

    axios(config)
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.data.msg &&
          response.data.status === false &&
          response.data.msg.includes("Invalid Token")
        ) {
          dispatch(LogOutAction());
        }

        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length !== 0
        ) {
          dispatch({
            type: GET_LIKE_ITEMS,
            payloadLikeItemsList: response.data.data,
          });
        } else {
          dispatch({
            type: GET_LIKE_ITEMS_ERROR,
            payload: "your wish list is empty",
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: GET_LIKE_ITEMS_ERROR,
          payload: "server response failed",
        });
      });
  } catch (e) {}
};

export const addRemoveLikeItemsAction =
  (projectId, type = "like") =>
  async (dispatch, getState) => {
    dispatch({
      type: LIKE_UNLIKE_SERVER_SIDE_LOADING,
    });

    if (type === "like") {
      dispatch({
        type: LIKE_ITEM_VALUE_ADD,
        payloadLikeId: projectId,
      });
    } else if (type === "unlike") {
      dispatch({
        type: UNLIKE_ITEM_VALUE_REMOVE,
        payloadUnLikeId: projectId,
      });
    }

    try {
      const {
        authState: { userToken },
      } = getState();

      var dataObj = JSON.stringify({ id: projectId });

      const likeUnlikeUrl =
        type === "like"
          ? "https://admin.aynajewels.in/amrut1api/home/add_wishlist"
          : "https://admin.aynajewels.in/amrut1api/home/remove_wishlist";

      var config = {
        method: "post",
        url: likeUnlikeUrl,
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: dataObj,
      };

      axios(config)
        .then(function (response) {
          if (
            response &&
            response.data &&
            response.data.msg &&
            response.data.status === false &&
            response.data.msg.includes("Invalid Token")
          ) {
            dispatch(LogOutAction());
          }

          if (response && response.data && response.data.status) {
            toast.success(
              type === "like"
                ? "Item successfully added into wishlist"
                : "Item successfully removed from wishlist"
            );
            dispatch({
              type: LIKE_UNLIKE_SERVER_SIDE_ERROR_DONE,
            });
          } else {
            dispatch({
              type: LIKE_UNLIKE_SERVER_SIDE_ERROR_DONE,
            });
          }
        })
        .catch(function (error) {
          dispatch({
            type: LIKE_UNLIKE_SERVER_SIDE_ERROR_DONE,
          });
        });
    } catch (e) {}
  };

export const getOrderListAction = () => async (dispatch, getState) => {
  dispatch({
    type: LIST_ORDER_ITEM_LOADING,
  });

  dispatch({
    type: PRODUCT_RESET,
  });

  try {
    const {
      authState: { userToken },
    } = getState();

    var emptyObj = JSON.stringify({});

    var config = {
      method: "post",
      url: "https://admin.aynajewels.in/amrut1api/order/list_order",
      headers: {
        "If-Range": userToken,
        "Content-Type": "application/json",
      },
      data: emptyObj,
    };

    axios(config)
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.data.msg &&
          response.data.status === false &&
          response.data.msg.includes("Invalid Token")
        ) {
          dispatch(LogOutAction());
        }

        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length !== 0
        ) {
          dispatch({
            type: LIST_ORDER_ITEM,
            payloadOrderList: response.data.data,
          });
        } else {
          dispatch({
            type: LIST_ORDER_ITEM_ERROR,
            payloadOrderListError: "your order list is empty",
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: LIST_ORDER_ITEM_ERROR,
          payloadOrderListError: "server response failed",
        });
      });
  } catch (e) {}
};

export const placeOrderCardItemAction =
  (
    stamp = "",
    finishing = "",
    rhodium = "",
    screw_type = "",
    patch_details = "",
    navigate
  ) =>
  async (dispatch, getState) => {
    dispatch({
      type: PLACE_ORDER_ITEMS_LOADING,
    });

    try {
      const {
        authState: { userToken },
      } = getState();

      var emptyObj = JSON.stringify({
        stamp: stamp,
        finishing: finishing,
        rhodium: rhodium,
        screw_type: screw_type === "north" ? "North Screw" : "South Screw",
        patch_details:
          patch_details === "with" ? "With Patch" : "With Out Patch",
      });

      var config = {
        method: "post",
        url: "https://admin.aynajewels.in/amrut1api/order",
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: emptyObj,
      };

      axios(config)
        .then(function (response) {
          if (
            response &&
            response.data &&
            response.data.msg &&
            response.data.status === false &&
            response.data.msg.includes("Invalid Token")
          ) {
            dispatch(LogOutAction());
          }

          if (
            response &&
            response.data &&
            response.data.status &&
            response.data.status === true
          ) {
            toast.success(
              response.data.message
                ? response.data.message
                : "Order Placed Successfully"
            );

            dispatch(getLikeCardItemsAction());
            dispatch(getCardItemsAction());
            dispatch(getOrderListAction());
            // navigate("/order");
            navigate("/thankyou", {
              state: {
                title: "For your purchase and for supporting small business!",
                path: "/order",
                btntitle: "Continue To Order",
              },
            });

            dispatch({
              type: PLACE_ORDER_ITEMS,
            });
          } else {
            toast.success(
              response.data && response.data.message
                ? response.data.message
                : "something is wrong, try again"
            );

            dispatch({
              type: PLACE_ORDER_ITEMS_ERROR,
            });
          }
        })
        .catch(function (error) {
          toast.success("server response failed, try again");

          dispatch({
            type: PLACE_ORDER_ITEMS_ERROR,
          });
        });
    } catch (e) {}
  };

export const filterTypesAction = () => async (dispatch, getState) => {
  try {
    const {
      authState: { userToken },
    } = getState();

    var emptyObj = JSON.stringify({});

    var config = {
      method: "post",
      url: "https://admin.aynajewels.in/amrut1api/filter",
      headers: {
        "If-Range": userToken,
        "Content-Type": "application/json",
      },
      data: emptyObj,
    };

    axios(config)
      .then(function (response) {
        let genderAddCheck;
        let SubCategoryAddCheck;
        let CategoryAddCheck;
        let ItemGroupAddCheck;

        if (
          response &&
          response.data &&
          response.data.status === false &&
          response.data.msg.includes("Invalid Token")
        ) {
          dispatch(LogOutAction());
        }

        if (response && response.data && response.data.data) {
          genderAddCheck = response.data.data.gender
            ? response.data.data.gender.map((item) => ({
                ...item,
                check: false,
              }))
            : [];

          SubCategoryAddCheck = response.data.data.sub_category
            ? response.data.data.sub_category.map((item) => ({
                ...item,
                check: false,
              }))
            : [];

          CategoryAddCheck = response.data.data.category
            ? response.data.data.category.map((item) => ({
                ...item,
                check: false,
              }))
            : [];

          ItemGroupAddCheck = response.data.data.item_group
            ? response.data.data.item_group.map((item) => ({
                ...item,
                check: false,
              }))
            : [];
        } else {
          genderAddCheck = [];
          SubCategoryAddCheck = [];
          CategoryAddCheck = [];
          ItemGroupAddCheck = [];
        }

        dispatch({
          type: GET_FILTER_VALUE,
          payloadGender: genderAddCheck,
          payloadSubCategory: SubCategoryAddCheck,
          payloadCategory: CategoryAddCheck,
          payloadItemGroup: ItemGroupAddCheck,
        });
      })
      .catch(function (error) {});
  } catch (e) {}
};

export const getCardItemsAction = () => async (dispatch, getState) => {
  dispatch({
    type: GET_CARD_ITEMS_LOADING,
  });

  try {
    const {
      authState: { userToken },
    } = getState();

    dispatch({
      type: PRODUCT_RESET,
    });

    var emptyObj = JSON.stringify({});

    var config = {
      method: "post",
      url: "https://admin.aynajewels.in/amrut1api/home/cart",
      headers: {
        "If-Range": userToken,
        "Content-Type": "application/json",
      },
      data: emptyObj,
    };

    axios(config)
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.data.msg &&
          response.data.status === false &&
          response.data.msg.includes("Invalid Token")
        ) {
          dispatch(LogOutAction());
        }

        if (response && response.data && response.data.status) {
          let totalReposneQty =
            response.data.totaldata && response.data.totaldata.total_qty
              ? response.data.totaldata.total_qty
              : 0;
          let totalReponseGr =
            response.data.totaldata && response.data.totaldata.total_gr
              ? response.data.totaldata.total_gr
              : 0;

          dispatch({
            type: SET_CARD_QTY_AND_TOTAL,
            payloadTotalCardvalue: parseFloat(totalReponseGr),
            payloadQty: parseInt(totalReposneQty),
          });
        }

        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length !== 0
        ) {
          dispatch({
            type: GET_CARD_ITEMS,
            payloadCardList: response.data.data,
          });
        } else {
          dispatch({
            type: GET_CARD_ITEMS_ERROR,
            payload: "your card is empty",
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: GET_CARD_ITEMS_ERROR,
          payload: "server response failed",
        });
      });
  } catch (e) {}
};

export const getGroupAndSizeId = () => async (dispatch, getState) => {
  dispatch({
    type: GET_GROUP_SIZE_LOADING,
  });

  try {
    const {
      authState: { userToken },
    } = getState();

    var objData = JSON.stringify({
      offset: 0,
      limit: 0,
      sub_category: "",
      gender: "",
      item_group: "",
      category: "",
      search_text: "",
    });
    if (userToken) {
      var config = {
        method: "post",
        url: "https://admin.aynajewels.in/amrut1api/home/sizeandgroup",
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: objData,
      };
    } else {
      var config = {
        method: "post",
        url: "https://admin.aynajewels.in/amrut1api/login",
        headers: {
          "If-Match": "SIZE",
          "Content-Type": "application/json",
        },
        data: objData,
      };
    }

    axios(config)
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.data.msg &&
          response.data.status === false &&
          response.data.msg.includes("Invalid Token")
        ) {
          dispatch(LogOutAction());
        }

        if (response && response.data && response.data.data) {
          dispatch({
            type: GET_GROUP_SIZE_LIST,
            sizeList:
              Array.isArray(response.data.data.size) && response.data.data.size
                ? response.data.data.size
                : [],
            groupListItems:
              Array.isArray(response.data.data.group) &&
              response.data.data.group
                ? response.data.data.group
                : [],
          });
        } else {
          dispatch({
            type: GET_CARD_ITEMS_ERROR,
            payload: "your card is empty",
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: GET_GROUP_SIZE_LIST_ERROR,
          payload: "server response failed",
        });
      });
  } catch (e) {}
};

export const editOrderItemAction =
  (orderId = "0", navigate) =>
  async (dispatch, getState) => {
    dispatch({
      type: EDIT_ORDER_ITEM_LOADING,
    });

    try {
      const {
        authState: { userToken },
      } = getState();

      var emptyObj = JSON.stringify({});

      var config = {
        method: "post",
        url: `https://admin.aynajewels.in/amrut1api/order/edit_order/${orderId}`,
        headers: {
          "If-Range": userToken,
          "Content-Type": "application/json",
        },
        data: emptyObj,
      };

      axios(config)
        .then(function (response) {
          if (
            response &&
            response.data &&
            response.data.msg &&
            response.data.status === false &&
            response.data.msg.includes("Invalid Token")
          ) {
            dispatch(LogOutAction());
          }

          if (
            response &&
            response.data &&
            response.data.status &&
            response.data.status === true
          ) {
            dispatch(getCardItemsAction());
            dispatch(getOrderListAction());
            navigate("/cart");
            toast.success(
              response.data.message
                ? response.data.message
                : "Order added into cart successfully"
            );

            dispatch({
              type: EDIT_ORDER_ITEM_BY_ID,
            });
          } else {
            toast.success("something is wrong, try again");

            dispatch({
              type: EDIT_ORDER_ITEM_ERROR,
            });
          }
        })
        .catch(function (error) {
          toast.success("server response failed, try again");

          dispatch({
            type: EDIT_ORDER_ITEM_ERROR,
          });
        });
    } catch (e) {}
  };

export const ProductDetailIndexAction = (id, item) => async (dispatch) => {
  dispatch({
    type: PRODUCT_DETAIL_INDEX,
    payload: id,
    payloaditem: item,
  });
  window.$("#productdetailmodal").modal("show");
};

export const getSizeId = (id) => async (dispatch, getState) => {
  dispatch({
    type: GET_SIZE_LOADING,
  });

  try {
    if(!id) return;
    const {
      authState: { userToken },
    } = getState();

    var objData = JSON.stringify({
      item_id: id,
    });

    console.log(objData);

    var config = {
      method: "post",
      url: "https://admin.aynajewels.in/amrut1api/home/size",
      headers: {
        "If-Range": userToken,
        "Content-Type": "application/json",
      },
      data: objData,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data);
        if (
          response &&
          response.data &&
          response.data.msg &&
          response.data.status === false &&
          response.data.msg.includes("Invalid Token")
        ) {
          dispatch(LogOutAction());
        }

        if (response && response.data && response.data.data) {
          dispatch({
            type: GET_SIZE_LIST,
            sizeList:
              Array.isArray(response.data.data.size) && response.data.data.size
                ? response.data.data.size
                : [],
          });
        } else {
          dispatch({
            type: GET_CARD_ITEMS_ERROR,
            payload: "your card is empty",
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: GET_SIZE_LIST_ERROR,
          payload: "server response failed",
        });
      });
  } catch (e) {}
};

export const OrderbyToggleAction =
  (toggle, id, isfilter) => async (dispatch, getState) => {
    const {
      productState: { globlecatid },
    } = getState();

    await dispatch({
      type: ORDERBY_TOGGLE,
      payload: toggle,
    });
    dispatch({
      type: PRODUCT_RESET,
    });
    dispatch(applyFilterAction(globlecatid));
  };

export const GlobleCategoryIdAction = (id) => async (dispatch) => {
  await dispatch({
    type: GLOBLE_CATEGORY_ID,
    payload: id,
  });
};
